import React, { useCallback, useEffect, useState } from "react";
import api from "../api/api";
import useAutoRefresh from "../hooks/useAutoRefresh";

function Avaliacoes() {
  const [avaliacoes, setAvaliacoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notaFiltro, setNotaFiltro] = useState(0);

  const fetchAvaliacoes = useCallback(async (silent = false) => {
    if (!silent) setLoading(true);
    try {
      const res = await api.get("/avaliacoes");
      setAvaliacoes(res.data);
    } catch (err) {
      setAvaliacoes([]);
    } finally {
      if (!silent) setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAvaliacoes(false);
  }, [fetchAvaliacoes]);

  useEffect(() => {
    const handler = () => fetchAvaliacoes(true);
    window.addEventListener("fz:agendamento", handler);
    window.addEventListener("fz:notificacao", handler);
    return () => {
      window.removeEventListener("fz:agendamento", handler);
      window.removeEventListener("fz:notificacao", handler);
    };
  }, [fetchAvaliacoes]);

  useAutoRefresh(() => fetchAvaliacoes(true), 15000, true);

  const avaliacoesFiltradas = notaFiltro > 0
    ? avaliacoes.filter((a) => a.nota === notaFiltro)
    : avaliacoes;

  return (
    <div>
      <h2>Avaliações dos Clientes</h2>
      <div style={{ marginBottom: 16 }}>
        <label>Filtrar por nota: </label>
        <select value={notaFiltro} onChange={e => setNotaFiltro(Number(e.target.value))}>
          <option value={0}>Todas</option>
          {[1,2,3,4,5].map(n => <option key={n} value={n}>{n}</option>)}
        </select>
      </div>
      {loading ? (
        <p>Carregando avaliações...</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Nota</th>
              <th>Comentário</th>
              <th>Cliente</th>
              <th>Profissional</th>
              <th>Serviço/Agendamento</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            {avaliacoesFiltradas.map((a) => (
              <tr key={a.id}>
                <td>{a.nota}</td>
                <td>{a.comentario}</td>
                <td>{a.usuario_nome || a.usuario_id}</td>
                <td>{a.profissional_nome || a.profissional_id}</td>
                <td>{a.servico_nome || a.agendamento_id}</td>
                <td>{new Date(a.data_avaliacao).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default Avaliacoes;
